var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "CardBodyItem",
        {
          attrs: {
            label: "Suggested Resources",
            labelClass: "w-full",
            contentContainerClass: "pl-2",
          },
        },
        [_vm.resourcesExist ? _c("span") : _vm._e()]
      ),
      _vm.isLoading
        ? _c("SuitableResourcesPlaceholder")
        : _vm.resourcesExist
        ? _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.suitableContractors,
              moreNumber: _vm.resourcesCount,
              navigateTo: undefined,
              limit: 2,
              isPerson: "",
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ highlighted, itemName }) {
                  return [
                    highlighted
                      ? _c("span", { staticClass: "truncate text-primary" }, [
                          _vm._v(" " + _vm._s(itemName) + " "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }